// Shared by ViewerHud and the screenshot HUD, so the PNG and the screen show the same timer.
export default function formatTimer(secondsLeft, isBomb) {
  if (secondsLeft <= 0) {
    return isBomb ? '0.0' : '0:00';
  }

  if (isBomb) {
    const secs = Math.floor(secondsLeft);
    const tenths = Math.floor((secondsLeft - secs) * 10);
    return `${secs}.${tenths}`;
  }
  const mins = Math.floor(secondsLeft / 60);
  const secs = Math.floor(secondsLeft % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}
